import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from "recharts";
import '../StockChart/StockChart.css';

const data = [
    { date: "2014-12-18", value: 5 },
    { date: "2015-03-01", value: 7 },
    { date: "2015-06-18", value: 10 },
    { date: "2015-09-15", value: 11 },
    { date: "2016-01-18", value: 12 },
    { date: "2016-05-01", value: 14 },
    { date: "2016-08-26", value: 15 },
    { date: "2016-12-01", value: 17 },
    { date: "2017-03-15", value: 18 },
    { date: "2017-05-08", value: 20 },
    { date: "2017-10-01", value: 22 },
    { date: "2018-01-01", value: 25 },
    { date: "2018-03-01", value: 27 },
    { date: "2018-05-08", value: 30 },
    { date: "2018-10-01", value: 35 },
    { date: "2019-01-01", value: 40 },
    { date: "2019-06-01", value: 50 },
    { date: "2020-01-15", value: 60 },
    { date: "2020-06-01", value: 70 },
    { date: "2020-09-15", value: 80 },
    { date: "2020-12-15", value: 85 },
    { date: "2021-01-15", value: 90 },
    { date: "2021-03-01", value: 92 },
    { date: "2021-05-01", value: 95 },
    { date: "2021-07-01", value: 98 },
    // { date: "2021-09-22", value: 100 },
    // { date: "2022-01-01", value: 120 },
    // { date: "2022-06-01", value: 135 },
    // { date: "2022-12-31", value: 150 },
    // { date: "2023-03-01", value: 165 },
    // { date: "2023-06-01", value: 180 },
    // { date: "2023-09-01", value: 185 },
    // { date: "2024-01-01", value: 190 },
    // { date: "2024-06-01", value: 195 },
    // { date: "2024-12-18", value: 202.2 },
  ];
  
  

const StockChart = () => {
  return (
    <div className="stock-container">
      <h2>Stock Value Progression Over Time: A Historical Line Chart</h2>
    <ResponsiveContainer width="100%" height={400}>
      <LineChart 
         data={data}
         margin={{ top: 20, right: 40, bottom: 20, left: 10 }}>
        <CartesianGrid stroke="#e8e8e8" strokeDasharray="dashLength spaceLength" vertical={false} />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend layout="horizontal" verticalAlign="bottom" align="center" /> {/* Add Legend */}
        {/* Use "monotone" for a smooth line */}
        <Line
          type="monotone"
          dataKey="value"
          stroke="#4a90e2"
          strokeWidth={4}
          dot={false} // Removes dots on the line
        />
      </LineChart>
    </ResponsiveContainer>
    </div>
  );
};


export default StockChart